import { Component, Input } from '@angular/core';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxBulletModule } from 'devextreme-angular/ui/bullet';
import { CardAnalyticsComponent } from '../card-analytics/card-analytics.component';

@Component({
  selector: 'dk-revenue-analysis-card',
  templateUrl: './revenue-analysis-card.component.html',
  styleUrls: ['./revenue-analysis-card.component.scss'],
  standalone: true,
  imports: [CardAnalyticsComponent, DxDataGridModule, DxBulletModule],
})
export class RevenueAnalysisCardComponent {
  @Input() data: any;
}
